<template>
    <div>
        <v-form ref="form">
            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field 
                        outlined
                        dense
                        label="Name"
                        :rules="[isRequired]"
                        v-model="form.name"
                        hide-details="auto"
                    />
                </v-col>
            </v-row>
            <v-row
                v-if="!permLoading"
            >
                <v-col>
                    <v-col cols="12" md="3">
                        <v-text-field
                            label="Search Role"
                            outlined
                            rounded
                            dense
                            color="gray"
                            v-model="permissionSearch"
                            append-icon="mdi-magnify"
                            hide-details="auto"
                        >
                        </v-text-field>
                    </v-col>

                    <v-treeview
                        v-model="form.permissions"
                        :items="permissions"
                        selectable
                        selected-color="primary"
                        dense
                        open-all
                        :search="permissionSearch"
                        >
                    </v-treeview>
                </v-col>
            </v-row>
            <v-row v-else>
               <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import { isRequired, isNumeric } from './../../utils/validations'
import permission from "./../../services/administration/permission"
export default {
    props: {
        value: Object
    },
    data() {
        return {
            isRequired,
            isNumeric,
            permLoading: false,
            permissions: [],
            form: {
                name: "",
                permissions: []
            },
            permissionSearch: ""
        }
    },
    watch: {
        form: {
            deep: true,
            handler(value) {
                this.$emit("input", {...value})
            }
        }
    },
    methods: {
        fetchPermissions() {
            this.permLoading = true
            permission.tree().then(response => {
            this.permissions = response.data
            }).finally(() => {
                this.permLoading = false
            })
        },
        validate() {
            return this.$refs.form.validate()
        }
    },
    created(){
        this.fetchPermissions()
        if(this.value) {
            this.form = { ...this.form, ...this.value}
        }
    }
}
</script>
<style >

</style>

